import { push } from 'connected-react-router'
import { call, put, takeLatest, delay, select } from "redux-saga/effects";
import ActionTypeConstants from "helpers/ActionTypeConstants";
import { actionApiCall } from "helpers/api/ApiCalls";

const getSelected = state => state.UserOrgSiteReducer.selected;

function* submitEditRemediationPlanFormSaga({ payload }) {
    try {
        const selected = yield select(getSelected);
        const apiResponse = yield call(actionApiCall, {
            actionType: ActionTypeConstants.SUBMIT_EDIT_REMEDIATION_PLAN_FORM,
            data: {
                organization: selected.org,
                site: payload.site,
                associated_gap: payload.associated_gap,
                end_date: payload.end_date,
                estimated_cost: payload.estimated_cost,
                id: payload.id,
                notes: payload.notes,
                start_date: payload.start_date,
                status: payload.status,
                title: payload.title,
                tasks: payload.tasks,
                user_id: payload.user_id,
                owner: payload.owner,
            }
        });
        if (apiResponse.res.data.response === 200) {
            yield put({
                type: ActionTypeConstants.SUBMIT_EDIT_REMEDIATION_PLAN_FORM_SUCCESS,
                payload
            });
            yield put({ type: ActionTypeConstants.LOAD_REMEDIATION_PLANS });
            yield put(push('/achieve/remediation'));
            yield put({
                type: ActionTypeConstants.SHOW_ALERT,
                payload: {
                    message: apiResponse.res.message || "Successfully updated remediation plan",
                    color: "success"
                }
            });
            yield delay(10000);
            yield put({ type: ActionTypeConstants.HIDE_ALERT });
        } else {
            yield put({
                type: ActionTypeConstants.SHOW_ALERT,
                payload: {
                    message: apiResponse.res.message || "We ran into an issue while update remediation plan",
                    color: "danger"
                }
            });
            yield delay(10000);
            yield put({ type: ActionTypeConstants.HIDE_ALERT });

        }
    } catch (err) {
        yield put({
            type: ActionTypeConstants.SHOW_ALERT,
            payload: {
                message: "We ran into an issue while update remediation plan",
                color: "danger"
            }
        });
        yield delay(10000);
        yield put({ type: ActionTypeConstants.HIDE_ALERT });
    }
}

export default function* () {
    yield takeLatest( ActionTypeConstants.SUBMIT_EDIT_REMEDIATION_PLAN_FORM, submitEditRemediationPlanFormSaga);
}
